/**
 * fetches an alternative template
 * e.g. if on the product page, /?view=head will fetch the html generated from templates/product.head.liquid
 *
 */
export async function getAlternateTemplate(path, view, urlParamObj) {
    let urlParams = '';
    if (urlParamObj) {
        urlParams = Object.entries(urlParamObj).reduce((acc, curr) => {
            acc += `&${curr[0]}=${curr[1]}`;
            return acc;
        }, '');
    }
    const url = `${path}/?view=${view}${urlParams}`;
    console.log("fetching alternate template", url);
    const res = await fetch(url);
    // if the response is redirected, it seems the body returned is incorrect (i.e. it returns the entirety of the current page's html)
    if (res.ok) {
        const text = await res.text();
        // some redirects are fine (like if a product is requested under a collection but doesn't exist within that collection (i.e. collections/sale/products/non-sale-product))
        // however, if a redirected request returns an entire page, it's most likely an error
        if (res.redirected && text.trim().startsWith("<!doctype html>")) {
            console.error(`Template request redirected, but served entire page html: ${url}`);
            throw new Error();
        }
        else {
            return text;
        }
    }
    else {
        console.error(`Unable to fetch alternate template: ${res.status} ${res.statusText} ${res.redirected ? "redirected" : ""}`);
        throw new Error();
    }
}
